import React, {useEffect} from 'react'
import styled from 'styled-components'
import { Heading, Card, Text, BaseLayout } from '@eggplant-finance/eggplant-uikit-theme'
import useI18n from 'hooks/useI18n'
import Page from 'components/layout/Page'
import FarmStakingCard from './components/FarmStakingCard'
// import LotteryCard from './components/LotteryCard'
import CakeStats from './components/CakeStats'
import TotalValueLockedCard from './components/TotalValueLockedCard'
import TwitterCard from './components/TwitterCard'
import Banner from './graph/banner-home.png';
import TransparentTotalValueLockedCard from "./components/TransperentTVLCard";
import TransparentCakeStats from "./components/TransparentCackeStats";


const Hero = styled.div`
  align-items: center;
  // background-image: url('/images/egguardo-bg.svg');
  // background-repeat: no-repeat;
  // background-position: top center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  margin-bottom: 0px;
  padding-top: 116px;
  text-align: left;

  ${({ theme }) => theme.mediaQueries.lg} {
    // background-image: url('/images/egguardo-bg.svg');
    // background-position: left center, right center;
    height: 165px;
    padding-top: 0;
  }
`

const Cards = styled(BaseLayout)`
  align-items: stretch;
  justify-content: stretch;
  margin-bottom: 48px;

  & > div {
    grid-column: span 6;
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      grid-column: span 8;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      grid-column: span 6;
    }
  }
`

// update each page background image
// document.body.style.backgroundImage = `${({ theme }) => (theme.isDark ? 'url(http://localhost:3001/images/nfts/banner-nfts.png)' : 'url(http://localhost:3001/images/nfts/banner-nfts.png)')}`;
// document.body.style.backgroundImage = `${({ theme }) => (theme.isDark ? 'url(\'http://localhost:3001/images/nfts/banner-nfts.png\')' : 'url(\'http://localhost:3001/images/nfts/banner-nfts.png\')')} `;


// right content main background bg color
// background-color: ${({ theme }) => (theme.isDark ? '#27262c' : 'white')};

const Home: React.FC = () => {
  const TranslateString = useI18n();

  const isMobile = window.matchMedia("(max-width: 500px)").matches

    const rootId = document.getElementById('root');
    rootId.className = 'home-bg';

  return (
    <Page>
      <img src={Banner} alt="logo"/>
      <div>
        <Cards>
          <FarmStakingCard />
          <TwitterCard />
            {isMobile ?
                <>
                <CakeStats />
                <TotalValueLockedCard/>
            </> : null}
        </Cards>
          {!isMobile ?
              <>
              <Card isDouble>
              <TransparentCakeStats/>
              <TransparentTotalValueLockedCard />
               </Card>
              </> : null
          }
      </div>
        <Hero>
            <Text fontSize="20px" bold>{TranslateString(578, 'The most EGGcellent NFT yield farm on the Binance Smart Chain.')}</Text>
        </Hero>
    </Page>
  )
}

export default Home
